<template>
  <div>
    <audio
      :src="audioSource"
      @ended="onAudioEnded"
      autoplay
      ref="audioPlayer"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MoBot",
  data() {
    return {
      audioSource: "",
    };
  },

  computed: {
    ...mapGetters(["isBusy", "isBrowserGame", "narrate"]),
  },
  watch: {
    narrate(audioSrc) {
      this.loadNewAudio(audioSrc);
    },
  },
  methods: {
    loadNewAudio(audioSrc) {
      audioSrc = audioSrc ? require("@/assets/audio/" + audioSrc) : "";
      if (audioSrc) {
        this.$store.commit("wait");
      }
      this.audioSource = audioSrc;
      this.$refs.audioPlayer.load();
    },
    onAudioEnded() {
      this.$store.commit("playerNext");
      this.loadNewAudio(false);
      //  this.$store.commit("continuer");
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style>
/* Füge hier bei Bedarf Styling hininzu */
</style>
